import React from 'react'
import styled from 'styled-components/macro'
import {
  StandardButton,
  StandardButtonSize,
  StandardButtonVariant,
} from 'src/components/Reusable/Buttons'
import { EroDarkEastSVG } from 'src/components/Icons/Brand'
import { MediumText } from 'src/global.styles/typography.styles'
import palette from 'src/designSystem/variables/palette'

const ButtonContainer = styled(StandardButton)`
  background: linear-gradient(90deg, #bb83ff 0%, #4381fd 100%);
  border-image-source: linear-gradient(90deg, #be8cff 0%, #5b8eff 100%);
  width: fit-content;
  gap: 8px;
  border-width: 1px;
  border-radius: 8px;
  padding-top: 10px;
  padding-right: 16px;
  padding-bottom: 10px;
  padding-left: 16px;
  span {
    color: ${palette.neutral.white};
    &:hover {
      color: ${palette.neutral[50]};
    }
  }
`

const AskTiIcon = styled(EroDarkEastSVG)`
  width: 16px;
  height: 16px;
  cursor: pointer;
`

export const AskTrusteroIntelligenceButton = ({
  onClick,
}: {
  onClick: () => void
}): JSX.Element => {
  return (
    <ButtonContainer
      buttonSize={StandardButtonSize.MEDIUM}
      variant={StandardButtonVariant.PRIMARY}
      onClick={onClick}
    >
      <AskTiIcon />
      <MediumText $isBold={true}>Ask Trustero Intelligence</MediumText>
    </ButtonContainer>
  )
}
